import React, { createContext, useContext, useState, ReactNode } from 'react';
import CreatePost from '../components/CreatePost';

interface PostContextType {
  openCreatePost: () => void;
  closeCreatePost: () => void;
}

const PostContext = createContext<PostContextType | undefined>(undefined);

export function usePost() {
  const context = useContext(PostContext);
  if (!context) {
    throw new Error('usePost must be used within a PostProvider');
  }
  return context;
}

export function PostProvider({ children }: { children: ReactNode }) {
  const [isCreatePostOpen, setIsCreatePostOpen] = useState(false);

  const openCreatePost = () => setIsCreatePostOpen(true);
  const closeCreatePost = () => setIsCreatePostOpen(false);

  return (
    <PostContext.Provider 
      value={{
        openCreatePost,
        closeCreatePost
      }}
    >
      {children}
      <CreatePost 
        isOpen={isCreatePostOpen}
        onClose={closeCreatePost}
      />
    </PostContext.Provider>
  );
}
